import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { ApiService } from '@services/api.service';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { VerificationDialog } from './verification-dialog';
import { MatDialog } from '@angular/material/dialog';
import { DataHelper } from '@helpers/data.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { WalletControl } from '@pipes/walletControl.pipe';
import { LocalizationService } from '@services/localization.service';

@Component({
  selector: 'account-credit-component',
  templateUrl: '../sharedTemplates/account-credit.component.html',
})
export class AccountCredit implements AfterViewInit, OnInit, OnDestroy {
  comboType = [];
  iban = '';
  customerInfo: any;
  ibanDropDownIsOpen = false;
  depositDropDownIsOpen = false;
  withdrawDropDownIsOpen = false;
  isIbanValid = true;
  isIbanCompleted = false;
  pay3000DropDownIsOpen = false;
  selectedComboType;
  quickRegisterDatas: UntypedFormGroup;
  isReSend = true;
  countryListLangAPI = [];
  //
  hasBirthplace = true;
  hasCountry = true;

  //
  constructor(
    private _FormBuilder: UntypedFormBuilder,
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _ApiService: ApiService,
    public dialog: MatDialog,
    private _LocalizationService: LocalizationService,
    public _DataHelper: DataHelper
  ) {
    this.isIbanCompleted = this._UserHelper.customerUser.IBAN.length > 0;

    this._DataHelper.selectedWallet.BranchType == 1 || this._DataHelper.selectedWallet.BranchType == 2
      ? this.openSetMontlyDialog()
      : (this.quickRegisterDatas = _FormBuilder.group({
          gender: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(3)]),
          eMail: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(2), Validators.email]),
          lastName: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(2)]),
          birthPlace: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(2)]),
          country: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(2)]),
          IsPromotion: new UntypedFormControl({ value: false, disabled: false }, []),
          checkBox2: new UntypedFormControl({ value: false, disabled: false }, [Validators.requiredTrue]),
        }));
  }
  ngAfterViewInit() {
    this.validIban(this.iban);
  }
  ngOnInit(): void {
    this.getCountryListLang();
    this.getQuickRegisterInfo();
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this._UserHelper.depositListListener.subscribe(x => {
      if (x === 'destroy') {
        this._UserHelper.depositList = [];
      } else {
        this.getDepositPayment();
      }
    });

    this._UserHelper.withdrawListListener.subscribe(x => {
      if (x === 'destroy') {
        this._UserHelper.withdrawList = [];
      } else {
        this.getWithdrawPayment();
      }
    });
    this.comboType = [
      { id: 2, name: 'Mrs' },
      { id: 1, name: 'Mr' },
    ];
  }
  getCountryListLang() {
    const walletControl = new WalletControl(this._UserHelper);
    this._ApiService.getCountryListLang().then(result => {
      this.countryListLangAPI = result;
      if (walletControl.transform(0, 'BranchType') && this.quickRegisterDatas) {
        this.quickRegisterDatas.controls.country.setValue(55);
      }
    });
  }

  ngOnDestroy() {
    this._UserHelper.depositListListener.emit('destroy');
    this._UserHelper.withdrawListListener.emit('destroy');
  }

  getDepositPayment(): void {
    this._ApiService.getAllDepositControl3().then(result => {
      if (result.length > 0) {
        this._UserHelper.depositList = result;
      }
    });
  }

  getWithdrawPayment(): void {
    this._ApiService.getAllWithdrawControl().then(result => {
      if (result.length > 0) {
        this._UserHelper.withdrawList = result;
      }
    });
  }

  openSetMontlyDialog() {
    // this._ApiService.getSelfLimits().then((x) => {
    //
    //   if (
    //     x[0].DepositMonthlyLimitConsumed === null &&
    //     ((this._UserHelper.walletList[0].IsVerification &&
    //     this._UserHelper.walletList[0].BranchType == 1 ) || this._UserHelper.walletList[0].BranchType == 2)
    //   ) {
    //     // if(x[0].DepositMonthlyLimitConsumed===null && this._UserHelper.walletList[0].BranchType==1)
    //     // const dialogRef = this.dialog.open(DepositLimitDialog, {
    //     //   width: "550px",
    //     //   panelClass: "transcationDialog",
    //     //   disableClose: true,
    //     // });
    //     // dialogRef.afterClosed().subscribe((result) => {
    //     //
    //     // });
    //   }
    // });
  }
  toggleDropDown(item) {
    if (item == 1) {
      this.ibanDropDownIsOpen = !this.ibanDropDownIsOpen;
    } else if (item == 2) {
      this.withdrawDropDownIsOpen = !this.withdrawDropDownIsOpen;
    } else if (item == 3) this.depositDropDownIsOpen = !this.depositDropDownIsOpen;
    else if (item == 4) this.pay3000DropDownIsOpen = !this.pay3000DropDownIsOpen;
  }

  walletSelectChange(walletItem) {
    this._UiHelper.setLoadingDialog(true);

    this._DataHelper.selectedWallet = walletItem;

    this._ApiService.switchWallet(walletItem.CustomerId, walletItem.BranchId).then(result => {
      this._ApiService
        .getClient()
        .then(res => {
          this._UiHelper.setLoadingDialog(false);
          this._UserHelper.setUser(res);
          this._UserHelper.depositListListener.emit('get');
          this._UserHelper.withdrawListListener.emit('get');
        })
        .catch();

      this._ApiService.getTaxRate().then(taxRateRes => {
        this._DataHelper.setTaxRate(taxRateRes);
      });
    });
  }
  saveIban() {
    if (this.validIbanRegex(this.iban)) {
      this._ApiService.getProcCustomerIBANUIDResult(this._UserHelper.customerUser.CustomerId, this.iban).then(result => {
        if (result && result.resultcode === 103) {
          this.isIbanValid = true;
          this.isIbanCompleted = true;
          this._ApiService
            .getClient()
            .then(result => {
              this._UserHelper.setUser(result);
              this._UiHelper.setLoadingDialog(false);
            })
            .catch();
        }
      });
    } else {
      const translator = new TranslatePipe(this._LocalizationService);

      const t_message = translator.transform('errorcode13', null);

      this._UiHelper.errorSnackBar(t_message, '');

      this.isIbanValid = false;
      this.isIbanCompleted = false;
    }
  }
  quickRegister() {
    this._ApiService.quickRegister(this.quickRegisterDatas.value).then(result => {
      if (result.resultcode == 151) {
        this._UiHelper.b3000SetAcountMobileState('close');
        if (this._UserHelper.customerUser != undefined && this._UserHelper.customerUser.CustomerId != undefined)
          this._ApiService.getWalletList().then(result => {
            this._UserHelper.walletList = result;
          });
        const dialogRef = this.dialog.open(VerificationDialog, {
          maxWidth: '85%',
          width: '85%',
          height: '55%',
          maxHeight: '55%',
          disableClose: true,
        });
        this._UiHelper.closeDimmer();
      } else {
        this._UiHelper.errorSnackBar(result.resultmessage, '');
      }
    });
    // Result başarılıysa conditionın içine yazılacak test için burada
  }
  getQuickRegisterInfo() {
    this._ApiService.getQuickRegisterInfo().then(result => {
      if (result && result.length > 0) {
        if (result[0].BirthPlace) {
          this.hasBirthplace = false;
          if (this.quickRegisterDatas) {
            this.quickRegisterDatas.controls.birthPlace.setValue(result[0].BirthPlace);
          }
        }
        if (result[0].Country) {
          this.hasCountry = false;
          if (this.quickRegisterDatas) {
            this.quickRegisterDatas.controls.country.setValue(result[0].Country);
          }
        }
        if (result[0].Email) {
          if (this.quickRegisterDatas) {
            this.quickRegisterDatas.controls.eMail.setValue(result[0].Email);
          }
        }
        if (this.quickRegisterDatas) {
          this.quickRegisterDatas.controls.gender.setValue(1);
        }
      }
    });
  }
  validIbanRegex(iban: string) {
    const ibanRegex = new RegExp('DE[a-zA-Z0-9]{2}\\s?([0-9]{4}\\s?){4}([0-9]{2})\\s?');
    return ibanRegex.test(iban);
  }
  validIban(value: any) {
    const rearrange = value.substring(4, value.length) + value.substring(0, 4);
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
    const alphaMap = {};
    const number = [];

    alphabet.forEach((alphabetValue, index) => {
      alphaMap[alphabetValue] = index + 10;
    });

    rearrange.split('').forEach((rearrangeValue, index) => {
      number[index] = alphaMap[value] || value;
    });

    return this.modulo(number.join('').toString(), 97) === 1;
  }

  modulo(aNumStr, aDiv) {
    let tmp: any = '';
    let i, r;
    for (i = 0; i < aNumStr.length; i++) {
      tmp += aNumStr.charAt(i);
      r = tmp % aDiv;
      tmp = r.toString();
    }
    return tmp / 1;
  }

  reSendConfirmation() {
    this.isReSend = !this.isReSend;

    this._ApiService.getResendConfirmationMail().then((x: any) => {
      setTimeout(() => {
        this.isReSend = !this.isReSend;
      }, 10000);
    });
  }
}
